import React from 'react';

const Whitelisting = ({ fill = '' }: { fill?: string }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <mask
      id="mask0_2043_39126"
      style={{ maskType: 'alpha' }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <rect width="24" height="24" fill={fill || '#D9D9D9'} />
    </mask>
    <g mask="url(#mask0_2043_39126)">
      <path
        d="M16.375 19L12.825 15.45L14.225 14.05L16.35 16.175L20.6 11.925L22 13.35L16.375 19ZM16.375 11L12.825 7.45L14.225 6.05L16.35 8.175L20.6 3.925L22 5.35L16.375 11ZM2 17V15H11V17H2ZM2 9V7H11V9H2Z"
        fill="#1C1B1F"
      />
    </g>
  </svg>
);

export default Whitelisting;
